import qs from 'query-string';
export default function parseQueryString() {
  return qs.parse(window.location.search);
}